module.exports = __webpack_public_path__ + "img/potencia_r_a_gray.5c8d6f76.svg";